<template>
  <div>
    <menubar />
    <div class="container">

      <div id="title" class="title-btn d-flex justify-content-between align-items-center">

        <div class="d-flex justify-content-start">
          <img src="/img/05_slash.svg" />
          <p class="h1">通知一覧</p>
        </div>

        <div>
          <Link :href="route('messages.create')"><button class=" btn btn-purple">新規作成</button></Link>
        </div>

      </div>

      <table class="table component_table">
        <tbody>
          <tr>
            <th scope="col" class="text-center th__header col-id">No</th>
            <th scope="col" class="text-center th__header col-title">タイトル</th>
            <th scope="col" class="text-center th__header col-status">ステータス</th>
            <th scope="col" class="text-center th__header col-date">通知日時</th>
            <th scope="col" class="text-center th__header col-important">重要アイコン</th>
            <th scope="col" class="text-center th__header col-delete">削除</th>
            <th scope="col" class="text-center th__header col-select">選択</th>
          </tr>
          <tr v-for="(message, index) in messages" :key="index">

            <td class="align-middle text-center fw-bold">
               {{ message.id}}
            </td>

            <td class="align-middle fw-bold">
               <Link :href="route('messages.show', {id:message.id})">{{ message.title }}</Link>
            </td>

            <td v-bind:class="[ ( new Date(message.scheduled_at_ymdhi) > new Date() && message.is_draft == 0 ) ? 'text-red align-middle text-center' : 'align-middle text-center']">
              {{ message.is_draft == 1 ? '作成中': new Date(message.scheduled_at_ymdhi) < new Date() ? '通知済み' : '通知予約中' }}
            </td>
            
            <td v-bind:class="[( new Date(message.scheduled_at_ymdhi) > new Date() && message.is_draft == 0 ) ? 'text-red align-middle text-center' : 'align-middle text-center']">
              {{ new Date(message.scheduled_at_ymdhi).toLocaleString('ja-JP',{'year': 'numeric', 'month' :'numeric','day': 'numeric', 'hour' : 'numeric', 'minute' : 'numeric'}) }}
            </td>
            
            <td v-bind:class="[message.is_important == '1' ? 'text-red align-middle text-center' : 'align-middle text-center']">
              {{ message.is_important == 1 ? '表示する' : '' }}
            </td>

            <td class="text-center align-middle" v-if="true">
              <button class="btn text-red" @click="() => deleteMessage(message.id)">削除</button>
            </td>

            <td class="text-center align-middle" v-if="true">
              <input type="checkbox" v-bind:value="message.id" v-model="selected" />
            </td>

          </tr>
        </tbody>
      </table>

      <div class="row div__delete">
        <div class="text-end">
          <button class="btn btn-red" style="font-size: 0.9rem" @click="() => deleteMessage(selected)">まとめて削除</button>
        </div>
      </div>

    </div>
    <footerComponent />
  </div>
</template>

<script>
import { defineComponent, reactive } from 'vue';
import { Link } from '@inertiajs/inertia-vue3'
import modal from '@/Pages/Components/modal.vue';
import menubar from '@/Pages/JVTA/menu_jvta.vue';
import footerComponent from "@/Pages/Components/footer.vue";
import axios from 'axios';
import { Inertia } from '@inertiajs/inertia'


export default defineComponent({
  setup () {
    const form = reactive({
      id: null,
    });

    function deleteMessage(id) {
      if (id.length === 0) {
        alert("削除する通知を選択してください");
        return;
      }
      if (!confirm('この操作はやり直せません')) {
        return;
      }
      if (id.length) {
        for (let iid of id) {
          axios.delete(route('messages.destroy', iid));
        }
      } else {
        axios.delete(route('messages.destroy', id));
      }
      Inertia.reload();
      alert("記事が削除されました");
    }
    return { form, deleteMessage }
  },
  components: {
    Link,
    menubar,
    modal,
    footerComponent,
  },
  props: {messages: Array},
  data() {
    return {
      selected: [],
    }
  }

},);
</script>

<style lang="scss" scoped>
// hogr
// タイトル部分「用語集一覧」のcss
.container {
  #title {
    margin: 3rem 0;
    img {
      width: 3rem;
      height: 3rem;
    }
    p {
      color: #333333;
    }
  }
  .title-btn {
    margin: 3rem 0;
    #title {
      margin: 0;
      img {
        width: 3rem;
        height: 3rem;
      }
      p {
        color: #666666;
      }
    }
  }
}

.table {
  table-layout: fixed;
  overflow-wrap: break-word;
  word-wrap: break-word;
}

.text-red {
  color: red;
}


.col-id {
  width: 3%;
  text-align: center;
}
.col-title {
  width: 50%;
}
.col-status {
  width: 10%;
}
.col-date {
  width: 15%;
}
.col-important {
  width: 10%;
}
.col-delte {
  width: 10%;
}

.col-select {
  width: 5%;
}

.th__header{
  padding-top:1rem;
  padding-bottom:1rem;
}

.div__delete{
  margin-bottom: 5rem;
}
</style>
